import { Input } from "semantic-ui-react";
import styled from "styled-components";

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background:#fafafa
`;

const TopNavContainer = styled.div`
  width: 100%;
  height: 80px;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const ContentContainer = styled.div`
  display: flex;
  flex: 1;
`;

const SideMenuContainer = styled.div`
  width: 14.65%;
  height: 100vh;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.white};
  overflow-y: auto;
`;

const RouteContainer = styled.div`
  flex-grow: 1;
  overflow: auto;
  height: 100vh;
  width: ${({ theme }) => `calc(100vw - ${theme.spacing(50)})`};
  background-color: "#FAFAFA";
  overflow-y: auto;
  // padding: ${({ theme }) => theme.spacing(4)};
`;



export const StyledInput = styled(Input)`
  &&& input[type='number'] {
    -webkit-appearance: none;
    -moz-appearance: textfield;
    appearance: none;
    margin: 0;
  }

  &&& input::-webkit-outer-spin-button,
  &&& input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export {
  MainContainer,
  TopNavContainer,
  ContentContainer,
  SideMenuContainer,
  RouteContainer,
};
